import * as yup from 'yup'

const schema = yup.object().shape({
  complements: yup.string().required(),
  document: yup.mixed().fileUpload({ fileGroup: 'pdfOnly', required: true }),
})

export default schema
